export interface UserEditorInitialValues {
  email: string
  name: string
  groupBefore: string
  groupAfter: string
}

export const userEditorInitialValues: UserEditorInitialValues = {
  email: '',
  name: '',
  groupBefore: '',
  groupAfter: '',
}
